// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '../../../lib/base';
import { ExitDialogButton } from '../button';

export default function LoadingWarningDialog({
  isOpen,
  onClose,
}: { readonly isOpen: boolean; readonly onClose: () => void }) {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        onClose();
      }}
      maxWidth="sm"
    >
      <DialogTitle>
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Uh Oh!</Typography>
          <ExitDialogButton dontShiftUp onCloseDialog={onClose} />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ padding: 1 }}>
        <Box sx={{ p: 2 }}>
          <Typography variant="body1">
            The PDF generation code is still loading. This means you may be on a slow internet connection or our server
            is experiencing issues. Please close this dialog, wait a few seconds, and try again. Depending on the speed
            of your internet connection, it may take up to 60 seconds for this function to be available.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions disableSpacing sx={{ flexDirection: { md: 'row', xs: 'column' }, alignItems: 'center' }}>
        <Button sx={{ width: '100%' }} variant="outlined" onClick={onClose}>
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
}
